<template>	
	<div class="view ">
    <div class="title">预约表单</div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true"  :model="formdata" class="form-inline">
				
					<el-form-item label="预约人姓名">
						<el-input v-model="formdata.name" placeholder="请输入姓名" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item label="联系号码">
						<el-input v-model="formdata.phone" placeholder="请输入手机号" class="w200" size="small"></el-input>
					</el-form-item>
					
					<el-form-item label="邀请人">
						<el-select class="mr10 w130" v-model="formdata.inviter" size="small" placeholder="请选择核销状态">

							<el-option label="全部"  value=""></el-option>
							<template v-for="(item, index) in employee_list" >
								<el-option :key="index"  :label="item.name" :value="item.id" ></el-option>
							</template>
						</el-select>              
					</el-form-item>
					<el-form-item label="项目">
						<el-select class="mr10 w130" v-model="formdata.goods_id" size="small" placeholder="请选择核销状态">
							<el-option label="全部"  value=""></el-option>
							<template v-for="(item, index) in goods_list" >
								<el-option :key="index"  :label="item.goods_name" :value="item.id"></el-option>
							</template>
							
							<!-- <el-option label="失败" :value="2"></el-option> -->
						</el-select>              
					</el-form-item>
					<el-form-item label="核销状态">
						<el-select class="mr10 w130" v-model="formdata.verification_status" size="small" placeholder="请选择核销状态">
							<el-option label="全部"  value=""></el-option>
							<template v-for="(item, index) in verification_status_list" >
								<el-option :key="index"  :label="item" :value="index"></el-option>
							</template>
						</el-select>              
					</el-form-item>
					<el-form-item label="预约码">
						<el-input v-model="formdata.verification_code" placeholder="请输入预约码" class="w200 " size="small"></el-input>
					</el-form-item>
					<el-form-item label="提交时间">
						<el-date-picker
							v-model="timeData1"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="预约时间">
						<el-date-picker
							v-model="timeData2"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
			    	
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="微信头像/昵称" align="center"  width="180px">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
						<img src="@/assets/imgs/userDefult.png" altwu width="60px" height="60px" v-else/>
						<p>{{scope.row.nickName}}</p>
					</template>
				</el-table-column>
				<el-table-column label="提交信息" >
					<template slot-scope="scope" >
						<p>预约人：{{scope.row.name}}</p>
						<p>号码：{{scope.row.phone}}</p>
						<p>提交时间：{{scope.row.create_time_text}}</p>
						<p>备注：{{scope.row.remark}}</p>
					</template>
				</el-table-column>
				<el-table-column  label="邀请人" align="center" width="180px">
					<template slot-scope="scope">
						<img :src="scope.row.inviter_pic" alt width="60px" height="60px" v-if="scope.row.inviter_pic"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
						<p>{{scope.row.inviter_name}}</p>
					</template>
				</el-table-column>

				<el-table-column  label="预约概况">
					<template slot-scope="scope" >
						<p v-if="scope.row.type == 1">预约项目：{{scope.row.goods_name}}</p>
						<p  v-if="scope.row.type == 2">预约医师：{{scope.row.employee_name}}</p>
						<p>预约时间：{{scope.row.appointment_time}}</p>
						<p>预约码：{{scope.row.verification_code}}</p>
						<p>核销状态：
              <!-- verification_status核销状态，0-待核销，1-已核销，2-已取消 -->
             <span v-if="scope.row.verification_status == 0">{{scope.row.verification_status_text}}</span> 
             <!-- 已核销，核销时间没字段 -->
             <span v-if="scope.row.verification_status == 1" style="color:#29A7F4">{{scope.row.verification_status_text}}（{{scope.row.appointment_time}}）</span> 
             <span v-if="scope.row.verification_status == 2" style="color:#F56C6C">{{scope.row.verification_status_text}}（{{scope.row.cancel_time_text}}  取消人：{{scope.row.cancel_name}}）</span> 
              </p>
					</template>
				</el-table-column>
			
				<el-table-column fixed="right" label="操作" width="220px">
					<template slot-scope="scope">
						<p>
							<el-button type="primary" size="small" icon="el-icon-edit"  @click="open(scope.row.verification_code,scope.row.id)" v-if="scope.row.verification_status==0">核销</el-button>
							<el-button type="primary" size="small"  disabled v-else>已核销</el-button>
              <!-- <el-button type="danger" size="small" v-if="scope.row.verification_status==0"  @click="cancelAppointment(scope.row.id)">取消预约</el-button>
              <el-button type="danger" size="small" disabled v-else >取消预约</el-button> -->
							 <el-button type="danger" size="small"   @click="cancelAppointment(scope.row.id)">取消预约</el-button>
						</p>
				
					</template>
				</el-table-column> 
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:page-size="page.pagesize"
					:current-page="page.pageindex"
					:total="page.total"
					@current-change="pageIndexChange"
				></el-pagination>
			</div>
		</div>
		
	</div>
</template>

<script>
	import api from "@/api.js";
	import { pagination } from "@/util/util.js";

	export default {
		name: 'yuyueform',

		filters: {//限制文本显示字数,超出部分用...代替
			ellipsis (value) {
				if (!value) return ''
				if (value.length > 10) {
					return value.slice(0,10) + '...'
				}
				return value
			}
		},
		data() {
		  return {
				verification_status_list:[],
				timeData1: [],
				timeData2: [],
				dialogForm: false,
				payData: null,
				formdata: {
					name:'',
					phone:'',
					page: 1, // 	整型 	必填 	- 	- 	页码
					verification_code: '', // 	核销码
					verification_status:'',//核销状态
					create_time_start:'',//提交时间
					create_time_end:'',
					begin_time_start:'',//预约时间
					begin_time_end:'',
					inviter: '',
					goods_id: '',
					eid: 0,
				},
				tabIndex: 0,
				timeData: [],
				tableData: [],
				employee_list:[],//员工列表
				goods_list:[],//项目列表
				page: {
					pageindex: pagination.pageIndex,
					pagesize: pagination.pageSize,
					total: pagination.total
				},

		    pickerOptions1: {
		      disabledDate(time) {
		        // return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
		      }
		    }
		  };
		},
		created() {
		  this.init();
		},
		methods: {
		  //初始化请求
		  init() {
		    this.querycustom();
			},
		  // 查询
		  querycustom() {
				if (this.timeData1 && this.timeData1.length > 0) {
					this.formdata.create_time_start = this.timeData1[0]
					this.formdata.create_time_end = this.timeData1[1]
					} else {
					this.formdata.create_time_start = ""
					this.formdata.create_time_end = ""
				}
				if (this.timeData2 && this.timeData2.length > 0) {
					this.formdata.begin_time_start = this.timeData2[0]
					this.formdata.begin_time_end = this.timeData2[1]
					} else {
					this.formdata.begin_time_start = ""
					this.formdata.begin_time_end = ""
				}
				this.formdata.page = this.page.pageindex;
		    this.axios
					.post(api.appointmentList, this.formdata)
					.then(response => {
						if (response.data.code == 0) {
							this.tableData = response.data.list;
							this.employee_list = response.data.employee_list
							this.goods_list = response.data.goods_list
							this.verification_status_list = response.data.verification_status_list
							this.page.total = response.data.all_page;
							this.page.pagesize = response.data.size;
						} 
					})
					.catch(() => {});
			},
		  searchcustomer() {
				// this.formdata.page = 1;
				this.page.total = 1
		    this.querycustom();
		  },
		  pageIndexChange(pageindex) {
		    this.page.pageindex = pageindex;
		    this.querycustom();
			},
			//核销弹框
			open(value,id){
				this.axios
            .post(api.checkAppointment,{id:id})
            //预约核销
						.then(res=>{
							if(res.data.code == 0){
								this.$message.success(res.data.msg);
								setTimeout(()=>{   //设置延迟执行
									this.init();
								},1000);
							}
						}).catch(res => {});

				// this.$confirm('是否确定核销?（核销码：'+ value +'）', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // })
				// .then(() => {
					
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '取消核销'
        //   });       
        // });
			},
      //取消预约
      cancelAppointment(id){
          this.axios
            .post(api.cancelAppointment,{id:id})
						.then(res=>{
							if(res.data.code == 0){
								this.$message.success(res.data.msg);
								setTimeout(()=>{   //设置延迟执行
									this.init();
								},2000);
							}
						}).catch(res => {});
      }
		}
	}
</script>

<style scoped>
.condition .el-form-item{margin-bottom: 10px;}
</style>